import AccountBalances from './accountBalances';

export interface AccountBalancesProps {
    setAssetListOverlayOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}
export default AccountBalances;